import { withIcon } from "../Icon"

export const IconPencil = withIcon(
  '<path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M20 6.963 17.037 4 5.185 15.852 4 20l4.148-1.185L20 6.963Zm-5.333-.593 2.963 2.963-2.963-2.963Zm-9.482 9.482 2.963 2.963-2.963-2.963Z"/>',
)
